import styles from '../PropertyPanel.module.css';

function ColorField({ label, value, onChange }) {
  return (
    <label className={styles.field}>
      <span className={styles.fieldLabel}>{label}</span>
      <div className={styles.colorRow}>
        <input
          type="color"
          className={styles.colorInput}
          value={value || '#000000'}
          onChange={(e) => onChange(e.target.value)}
        />
        <input
          type="text"
          className={styles.colorText}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder="inherit"
        />
      </div>
    </label>
  );
}

export default ColorField;
